import type { ReactNode } from "react";
import { DialogTitle, Stack, Typography } from "@mui/material";
import { DialogCloseButton } from "./DialogCloseButton";

export type DialogTitleWithCloseProps = {
  children: ReactNode;
  onClose: () => void;
  /** Optional controls rendered to the left of the close button. */
  actions?: ReactNode;
};

/**
 * A DialogTitle laying out a title on the left and a close button on the
 * right, with an optional actions slot in between. Encapsulates the
 * title/close boilerplate repeated across modals.
 */
export const DialogTitleWithClose = ({
  children,
  onClose,
  actions,
}: DialogTitleWithCloseProps) => (
  <DialogTitle
    sx={{
      m: 0,
      p: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
    }}
  >
    <Typography variant="h6" component="span">
      {children}
    </Typography>
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      {actions}
      <DialogCloseButton
        onClick={onClose}
        sx={{ color: (theme) => theme.palette.grey[500] }}
      />
    </Stack>
  </DialogTitle>
);
